import React, { useEffect } from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const LandingSlider = (props) => {
  const landingSlider = props.dataLandingSlider;
  useEffect(() => {
    // Dynamically load the Spline viewer script
    const script = document.createElement("script");
    script.type = "module";
    script.src = "https://unpkg.com/@splinetool/viewer@1.9.54/build/spline-viewer.js";
    document.body.appendChild(script);

    return () => {
      // Cleanup the script on component unmount
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div
      className="landing-slider"
      style={{
        width: "100%",
        height: "100vh", // Full viewport height
        position: "relative", // Ensures child elements can be positioned over the viewer
        overflow: "hidden",
      }}
    >
      {/* Spline Viewer */}
      <spline-viewer
        url={landingSlider[0].image_url}
        style={{
          width: "100%",
          height: "100%",
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: 0,
          opacity: .6,
        }}
      ></spline-viewer>

      {/* Overlay Text */}
      <div className="landing-page-bg">
        <div className="container">
          <div className="landing-page-div" dangerouslySetInnerHTML={{ __html: landingSlider[0].head }} />
        </div>
      </div>
    </div>
  );
};

export default LandingSlider;
